import React from 'react';
import { makeStyles } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
    root: {
        padding: '40px 0px',
        position: 'relative',
        boxSizing: 'border-box',
        [theme.breakpoints.down('xs')]: {
            margin: theme.spacing(2),
            width: '100%',
            maxHeight: `calc(100% - ${theme.spacing(4)}px)`,
            padding: `${theme.spacing(3)}px 0px`,
        },
    },
    closeBtn: {
        position: 'absolute',
        top: 0,
        right: 0,
        margin: 4,
    },
    title: {
        padding: '0px 30px 40px',
        boxSizing: 'border-box',
        '& .MuiTypography-root': {
            fontSize: '1.7rem',
            fontFamily: '"Montserrat", sans-serif',
        },
        [theme.breakpoints.down('xs')]: {
            padding: `0px ${theme.spacing(2)}px ${theme.spacing(3)}px`,
        },
    },
    content: {
        padding: '0px 30px',
        boxSizing: 'border-box',
        [theme.breakpoints.down('xs')]: {
            padding: `0px ${theme.spacing(2)}px`,
        },
    },
    actions: {
        padding: '40px 30px 0px',
        boxSizing: 'border-box',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('xs')]: {
            padding: `${theme.spacing(3)}px ${theme.spacing(2)}px 0px`,
        },
        '& .MuiButtonBase-root.MuiButton-root': {
            '& + .MuiButtonBase-root': {
                marginLeft: theme.spacing(3),
                [theme.breakpoints.down('xs')]: {
                    marginLeft: theme.spacing(2),
                },
            },
            [theme.breakpoints.down('xs')]: {
                width: '50%',
            },
        },
    },
    headerActions: {
        position: 'absolute',
        top: 0,
        right: 56,
        borderRight: '1px solid #d8d8d8',
        marginRight: 10,
        padding: '6px 26px 6px 0px',
        marginTop: 10,

        [theme.breakpoints.down('sm')]: {
            marginRight: 0,
            padding: '6px 16px 6px 0px',
        },

        '& .MuiSvgIcon-root': {
            cursor: 'pointer'
        },
        '& .MuiSvgIcon-root + .MuiSvgIcon-root': {
            marginLeft: 30,
            [theme.breakpoints.down('sm')]: {
                marginLeft: 15,
            },
        }
    },
}));

export const SimpleDialog = (props) => {
    const classes = useStyles(props);
    const {
        open,
        onClose,
        title,
        maxWidth,
        fullWidth = false,
        disableCustomAction = false,
        disableActions = false,
        headerActions = null
    } = props;

    return (<>
        {props.icon}
        <Dialog
            maxWidth={maxWidth}
            open={open}
            onClose={onClose}
            fullWidth={fullWidth}
            PaperProps={{
                className: classes.root
            }}
            {...props.dialogProps}
        >
            {headerActions ? <div className={classes.headerActions}>
                {headerActions.map((action, index) => <React.Fragment
                    key={`headerActions_${index}`}
                >
                    {action}
                </React.Fragment>)}
            </div> : null}
            <IconButton
                onClick={onClose}
                className={classes.closeBtn}
            >
                <CloseIcon />
            </IconButton>
            <DialogTitle className={classes.title}>{title}</DialogTitle>
            <DialogContent className={classes.content}>
                {props.children}
            </DialogContent>
            {!disableActions ? <DialogActions className={classes.actions}>
                {!disableCustomAction && <Button
                    onClick={(e) => {
                        e.stopPropagation();
                        onClose();
                    }}
                    color="primary"
                    variant={'outlined'}
                >
                    Отменить
                </Button>}
                {props.actions.map((action, index) => <React.Fragment key={index}>
                    {action}
                </React.Fragment>)}
            </DialogActions> : null}
        </Dialog>
    </>);
}
